import EmailFooterV2 from '../components/FooterV2';

interface EmailProps {
  userName: string
  courseName: string
  courseDate: string
  courseDuration: string
  instructor: string
  modality: string
  courseId: string
  session: string
  time: string
  address: string
  meetingLink: string
  companyName: string
}

export default function ClassConfirmationEmail({
  userName = "João Silva",
  courseName = "Fundamentos de Data Analytics",
  courseDate = "15 de abril de 2025",
  courseDuration = "120 minutos",
  instructor = "Ana Carolina Soares",
  modality = "Híbrido",
  courseId = "FA-2025-001",
  session = "1ª aula",
  time = "06:00 às 14:00",
  address = "Av. Paulista, 1000 - Sala 203, São Paulo - SP",
  meetingLink = "https://teams.microsoft.com/l/meetup-join/19%3ameeting_abc123@thread.v2/",
  companyName = "Empresa XYZ Ltda",
}: EmailProps) {
  return (
    <div style={{ margin: 0, padding: 0, fontFamily: "Arial, sans-serif", backgroundColor: "#ffffff" }}>
      {/* Responsive CSS Styles */}
      <style dangerouslySetInnerHTML={{
        __html: `
          @media only screen and (max-width: 600px) {
            .email-container { width: 100% !important; max-width: 100% !important; border-radius: 0 !important; }
            .body-content { padding: 24px 20px !important; }
            .header { padding: 16px !important; }
            .logo { width: 100px !important; }
            .title { font-size: 20px !important; margin: 12px 0 4px !important; }
            .subtitle { font-size: 14px !important; margin: 0 0 20px !important; }
            .badge { font-size: 12px !important; padding: 6px 12px !important; }
            .card { padding: 12px !important; margin-bottom: 6px !important; }
            .card-label { font-size: 11px !important; }
            .card-value { font-size: 14px !important; }
            .section-title { font-size: 16px !important; margin: 20px 0 8px !important; }
            .section-title svg { width: 25px !important; height: 25px !important; }
            .info-box { padding: 16px !important; }
            .info-box h3 { font-size: 15px !important; }
            .info-box p { font-size: 13px !important; }
            .info-list { font-size: 13px !important; }
            .btn { display: block !important; width: 100% !important; text-align: center !important; margin-bottom: 8px !important; }
            .btn-primary { padding: 14px 16px !important; font-size: 15px !important; }
            .list, .warning-list { font-size: 13px !important; padding-left: 16px !important; }
            .contact-box { padding: 16px !important; }
            .contact-title { font-size: 15px !important; }
            .contact-info { font-size: 13px !important; }
            .footer { padding: 20px 16px !important; }
            .footer-logo { width: 70px !important; }
            .social-icons { justify-content: center !important; gap: 20px !important; }
            .social-icon { width: 24px !important; height: 24px !important; }
          }
          @media only screen and (max-width: 480px) {
            .body-content { padding: 20px 16px !important; }
            .title { font-size: 18px !important; }
            .subtitle { font-size: 13px !important; }
            .card { padding: 10px !important; }
            .card-label { font-size: 10px !important; }
            .card-value { font-size: 13px !important; }
            .section-title { font-size: 15px !important; }
            .section-title svg { width: 22px !important; height: 22px !important; }
            .info-box { padding: 14px !important; }
            .btn-primary { padding: 12px 14px !important; font-size: 14px !important; }
            .social-icons { gap: 16px !important; }
            .social-icon { width: 22px !important; height: 22px !important; }
          }
        `
      }} />
      
      <table
        width="100%"
        border={0}
        cellSpacing={0}
        cellPadding={0}
        style={{ backgroundColor: "#ffffff", padding: "40px 0" }}
      >
        <tbody>
          <tr>
            <td align="center">
              <table
                className="email-container"
                width={600}
                border={0}
                cellSpacing={0}
                cellPadding={0}
                style={{ 
                  backgroundColor: "#FAFAFA", 
                  borderRadius: "12px", 
                  overflow: "hidden",
                  maxWidth: "600px",
                  margin: "0 auto"
                }}
              >
                <tbody>
                  {/* Header */}
                  <tr>
                    <td 
                      className="header"
                      align="center" 
                      style={{ 
                        backgroundColor: "#1F1746", 
                        padding: "20px",
                        textAlign: "center"
                      }}
                    >
                      <div style={{ textAlign: "center", width: "100%" }}>
                        <img
                          className="logo"
                          src="https://asset.brandfetch.io/idNdb_MPJ2/idFGj2lq6u.png?c=1dxbfHSJFAPEGdCLU4o5B"
                          alt="Logo Trivium"
                          width={120}
                          style={{ 
                            display: "block", 
                            width: "120px", 
                            height: "auto",
                            margin: "0 auto"
                          }}
                        />
                      </div>
                    </td>
                  </tr>

                  {/* Body */}
                  <tr>
                    <td 
                      className="body-content"
                      style={{ 
                        padding: "36px 30px", 
                        color: "#333333"
                      }}
                    >
                      {/* Badge + Title */}
                      <div style={{ textAlign: "center" }}>
                        <span
                          className="badge"
                          style={{
                            backgroundColor: "#d9f99d",
                            color: "#365314",
                            display: "inline-block",
                            padding: "8px 16px",
                            borderRadius: "999px",
                            fontSize: "13px",
                            fontWeight: 700,
                            marginBottom: "16px"
                          }}
                        >
                          🎉 Inscrição confirmada
                        </span>
                        <h1 
                          className="title"
                          style={{ 
                            fontSize: "24px", 
                            margin: "16px 0 6px", 
                            color: "#111111",
                            lineHeight: "1.3"
                          }}
                        >
                          Olá, {userName} 👋
                        </h1>
                        <p 
                          className="subtitle"
                          style={{ 
                            fontSize: "16px", 
                            margin: "0 0 24px", 
                            color: "#555555", 
                            lineHeight: "1.6"
                          }}
                        >
                          Você está inscrito(a) na formação pedagógica
                          <br />
                          <strong>{courseName}</strong>
                        </p>
                      </div>

                      {/* Cards principais - Responsive grid */}
                      <div className="cards-grid" style={{ margin: "6px 0 24px" }}>
                        <table width="100%" cellPadding={0} cellSpacing={0}>
                          <tbody>
                            <tr>
                              <td width="50%" style={{ padding: "8px" }}>
                                <div
                                  className="card"
                                  style={{
                                    background: "#ffffff",
                                    border: "1px solid #e5e7eb",
                                    borderRadius: "10px",
                                    padding: "16px",
                                    marginBottom: "8px"
                                  }}
                                >
                                  <div 
                                    className="card-label"
                                    style={{ 
                                      fontSize: "12px", 
                                      color: "#1F1746", 
                                      fontWeight: 700, 
                                      margin: "0 0 4px"
                                    }}
                                  >
                                    📅 Data
                                  </div>
                                  <div 
                                    className="card-value"
                                    style={{ 
                                      fontSize: "15px", 
                                      color: "#111",
                                      lineHeight: "1.4"
                                    }}
                                  >
                                    {courseDate}
                                  </div>
                                </div>
                              </td>
                              <td width="50%" style={{ padding: "8px" }}>
                                <div
                                  className="card"
                                  style={{
                                    background: "#ffffff",
                                    border: "1px solid #e5e7eb",
                                    borderRadius: "10px",
                                    padding: "16px",
                                    marginBottom: "8px"
                                  }}
                                >
                                  <div 
                                    className="card-label"
                                    style={{ 
                                      fontSize: "12px", 
                                      color: "#1F1746", 
                                      fontWeight: 700, 
                                      margin: "0 0 4px"
                                    }}
                                  >
                                    ⏳ Duração
                                  </div>
                                  <div 
                                    className="card-value"
                                    style={{ 
                                      fontSize: "15px", 
                                      color: "#111",
                                      lineHeight: "1.4"
                                    }}
                                  >
                                    {courseDuration}
                                  </div>
                                </div>
                              </td>
                            </tr>
                            <tr>
                              <td width="50%" style={{ padding: "8px" }}>
                                <div
                                  className="card"
                                  style={{
                                    background: "#ffffff",
                                    border: "1px solid #e5e7eb",
                                    borderRadius: "10px",
                                    padding: "16px",
                                    marginBottom: "8px"
                                  }}
                                >
                                  <div 
                                    className="card-label"
                                    style={{ 
                                      fontSize: "12px", 
                                      color: "#1F1746", 
                                      fontWeight: 700, 
                                      margin: "0 0 4px"
                                    }}
                                  >
                                    👨‍🏫 Instrutor(a)
                                  </div>
                                  <div 
                                    className="card-value"
                                    style={{ 
                                      fontSize: "15px", 
                                      color: "#111",
                                      lineHeight: "1.4"
                                    }}
                                  >
                                    {instructor}
                                  </div>
                                </div>
                              </td>
                              <td width="50%" style={{ padding: "8px" }}>
                                <div
                                  className="card"
                                  style={{
                                    background: "#ffffff",
                                    border: "1px solid #e5e7eb",
                                    borderRadius: "10px",
                                    padding: "16px",
                                    marginBottom: "8px"
                                  }}
                                >
                                  <div 
                                    className="card-label"
                                    style={{ 
                                      fontSize: "12px", 
                                      color: "#1F1746", 
                                      fontWeight: 700, 
                                      margin: "0 0 4px"
                                    }}
                                  >
                                    🌍 Modalidade
                                  </div>
                                  <div 
                                    className="card-value"
                                    style={{ 
                                      fontSize: "15px", 
                                      color: "#111",
                                      lineHeight: "1.4"
                                    }}
                                  >
                                    {modality}
                                  </div>
                                </div>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      {/* Informações do Curso */}
                      <h2 
                        className="section-title"
                        style={{ 
                          fontSize: "18px", 
                          color: "#111", 
                          margin: "24px 0 10px",
                          lineHeight: "1.3",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px"
                        }}
                      >
                        <svg 
                          width="29" 
                          height="29" 
                          viewBox="0 0 17.46 11.64" 
                          style={{ display: "inline-block", verticalAlign: "middle" }}
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path fill="#ff4a8f" d="M5.82,0c3.21,0,5.81,2.59,5.82,5.81,0,3.21-2.6,5.82-5.8,5.83L5.82,0h0Z"/>
                          <path fill="#3b65f5" d="M0,0c3.21,0,5.81,2.59,5.82,5.81,0,3.21-2.6,5.82-5.8,5.83L0,0h0Z"/>
                          <path fill="#c8e600" d="M11.64.03c3.21,0,5.81,2.59,5.81,5.79s-2.61,5.79-5.82,5.79V.03h0Z"/>
                        </svg>
                        Informações do Curso
                      </h2>
                      <div
                        className="info-box"
                        style={{
                          backgroundColor: "#ffffff",
                          borderRadius: "10px",
                          padding: "20px",
                          marginBottom: "16px"
                        }}
                      >
                        <h3 style={{ margin: "0 0 4px", fontSize: "16px", color: "#1F1746" }}>{courseName}</h3>
                        <p style={{ margin: "0 0 14px", fontSize: "14px", color: "#6b7280" }}>Analytics Essentials</p>
                        <table 
                          width="100%" 
                          cellPadding={0} 
                          cellSpacing={0} 
                          className="info-list"
                          style={{ fontSize: "14px", color: "#111" }}
                        >
                          <tbody>
                            <tr>
                              <td style={{ padding: "6px 0", verticalAlign: "top" }}>
                                🔖 <strong>ID da aula:</strong> {courseId}
                              </td>
                            </tr>
                            <tr>
                              <td style={{ padding: "6px 0", verticalAlign: "top" }}>
                                📌 <strong>Sessão:</strong> {session}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>

                      {/* Data & Horário */}
                      <h2 
                        className="section-title"
                        style={{ 
                          fontSize: "18px", 
                          color: "#111", 
                          margin: "24px 0 10px",
                          lineHeight: "1.3",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px"
                        }}
                      >
                        <svg 
                          width="29" 
                          height="29" 
                          viewBox="0 0 17.46 11.64" 
                          style={{ display: "inline-block", verticalAlign: "middle" }}
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path fill="#ff4a8f" d="M5.82,0c3.21,0,5.81,2.59,5.82,5.81,0,3.21-2.6,5.82-5.8,5.83L5.82,0h0Z"/>
                          <path fill="#3b65f5" d="M0,0c3.21,0,5.81,2.59,5.82,5.81,0,3.21-2.6,5.82-5.8,5.83L0,0h0Z"/>
                          <path fill="#c8e600" d="M11.64.03c3.21,0,5.81,2.59,5.81,5.79s-2.61,5.79-5.82,5.79V.03h0Z"/>
                        </svg>
                        Data e Horário
                      </h2>
                      <table width="100%" cellPadding={0} cellSpacing={0}>
                        <tbody>
                          <tr>
                            <td width="50%" style={{ padding: "8px" }}>
                              <div
                                className="card"
                                style={{
                                  background: "#f9fafb",
                                  border: "1px solid #e5e7eb",
                                  borderRadius: "10px",
                                  padding: "16px",
                                  marginBottom: "8px"
                                }}
                              >
                                <div 
                                  className="card-label"
                                  style={{ 
                                    fontSize: "12px", 
                                    color: "#1F1746", 
                                    fontWeight: 700
                                  }}
                                >
                                  📅 Data
                                </div>
                                <div 
                                  className="card-value"
                                  style={{ 
                                    fontSize: "15px", 
                                    color: "#111",
                                    lineHeight: "1.4"
                                  }}
                                >
                                  15 de abril de 2025
                                </div>
                              </div>
                            </td>
                            <td width="50%" style={{ padding: "8px" }}>
                              <div
                                className="card"
                                style={{
                                  background: "#f9fafb",
                                  border: "1px solid #e5e7eb",
                                  borderRadius: "10px",
                                  padding: "16px",
                                  marginBottom: "8px"
                                }}
                              >
                                <div 
                                  className="card-label"
                                  style={{ 
                                    fontSize: "12px", 
                                    color: "#1F1746", 
                                    fontWeight: 700
                                  }}
                                >
                                  🕓 Horário
                                </div>
                                <div 
                                  className="card-value"
                                  style={{ 
                                    fontSize: "15px", 
                                    color: "#111",
                                    lineHeight: "1.4"
                                  }}
                                >
                                  {time}
                                </div>
                              </div>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      {/* Local e Reunião */}
                      <h2 
                        className="section-title"
                        style={{ 
                          fontSize: "18px", 
                          color: "#111", 
                          margin: "24px 0 10px",
                          lineHeight: "1.3",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px"
                        }}
                      >
                        <svg 
                          width="29" 
                          height="29" 
                          viewBox="0 0 17.46 11.64" 
                          style={{ display: "inline-block", verticalAlign: "middle" }}
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path fill="#ff4a8f" d="M5.82,0c3.21,0,5.81,2.59,5.82,5.81,0,3.21-2.6,5.82-5.8,5.83L5.82,0h0Z"/>
                          <path fill="#3b65f5" d="M0,0c3.21,0,5.81,2.59,5.82,5.81,0,3.21-2.6,5.82-5.8,5.83L0,0h0Z"/>
                          <path fill="#c8e600" d="M11.64.03c3.21,0,5.81,2.59,5.81,5.79s-2.61,5.79-5.82,5.79V.03h0Z"/>
                        </svg>
                        Local e Reunião
                      </h2>
                      <div
                        className="info-box"
                        style={{
                          backgroundColor: "#ffffff",
                          borderRadius: "10px",
                          padding: "20px",
                          marginBottom: "16px"
                        }}
                      >
                        <p style={{ margin: "0 0 8px", fontSize: "14px", color: "#111" }}>
                          📌 <strong>Endereço:</strong> {address}
                        </p>
                        <p style={{ margin: "0 0 16px", fontSize: "14px", color: "#111" }}>
                          💻 <strong>Microsoft Teams</strong>
                        </p>
                        <div style={{ textAlign: "center" }}>
                          <a
                            href={meetingLink}
                            className="btn btn-primary"
                            style={{
                              backgroundColor: "#3b65f5",
                              color: "#ffffff",
                              textDecoration: "none",
                              padding: "12px 18px",
                              borderRadius: "8px",
                              fontSize: "14px",
                              fontWeight: "bold",
                              display: "inline-block",
                              cursor: "pointer",
                              transition: "background-color 0.3s ease",
                              maxWidth: "100%",
                              boxSizing: "border-box"
                            }}
                          >
                            Participar da Reunião
                          </a>
                        </div>
                      </div>

                      {/* Organização */}
                      <h2 
                        className="section-title"
                        style={{ 
                          fontSize: "18px", 
                          color: "#111", 
                          margin: "24px 0 10px",
                          lineHeight: "1.3",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px"
                        }}
                      >
                        <svg 
                          width="29" 
                          height="29" 
                          viewBox="0 0 17.46 11.64" 
                          style={{ display: "inline-block", verticalAlign: "middle" }}
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path fill="#ff4a8f" d="M5.82,0c3.21,0,5.81,2.59,5.82,5.81,0,3.21-2.6,5.82-5.8,5.83L5.82,0h0Z"/>
                          <path fill="#3b65f5" d="M0,0c3.21,0,5.81,2.59,5.82,5.81,0,3.21-2.6,5.82-5.8,5.83L0,0h0Z"/>
                          <path fill="#c8e600" d="M11.64.03c3.21,0,5.81,2.59,5.81,5.79s-2.61,5.79-5.82,5.79V.03h0Z"/>
                        </svg>
                        Organização
                      </h2>
                      <div
                        className="info-box"
                        style={{
                          backgroundColor: "#ffffff",
                          borderRadius: "10px",
                          padding: "20px",
                          marginBottom: "16px"
                        }}
                      >
                        <h3 style={{ margin: "0 0 6px", fontSize: "15px", color: "#1F1746" }}>{companyName}</h3>
                        <p style={{ margin: 0, fontSize: "13px", color: "#4b5563" }}>
                          🤝 Esta formação é uma iniciativa do {companyName}, em parceria com a Trivium.
                        </p>
                      </div>

                      {/* Próximos passos */}
                      <h2 
                        className="section-title"
                        style={{ 
                          fontSize: "18px", 
                          color: "#111", 
                          margin: "24px 0 10px",
                          lineHeight: "1.3",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px"
                        }}
                      >
                        <svg 
                          width="29" 
                          height="29" 
                          viewBox="0 0 17.46 11.64" 
                          style={{ display: "inline-block", verticalAlign: "middle" }}
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path fill="#ff4a8f" d="M5.82,0c3.21,0,5.81,2.59,5.82,5.81,0,3.21-2.6,5.82-5.8,5.83L5.82,0h0Z"/>
                          <path fill="#3b65f5" d="M0,0c3.21,0,5.81,2.59,5.82,5.81,0,3.21-2.6,5.82-5.8,5.83L0,0h0Z"/>
                          <path fill="#c8e600" d="M11.64.03c3.21,0,5.81,2.59,5.81,5.79s-2.61,5.79-5.82,5.79V.03h0Z"/>
                        </svg>
                        Próximos Passos
                      </h2>
                      <div
                        className="info-box"
                        style={{
                          backgroundColor: "#ffffff",
                          borderRadius: "10px",
                          padding: "20px",
                          marginBottom: "16px"
                        }}
                      >
                        <ul
                          className="list"
                          style={{
                            fontSize: "14px",
                            color: "#4b5563",
                            lineHeight: "1.8",
                            paddingLeft: "20px",
                            margin: 0
                          }}
                        >
                          <li style={{ marginBottom: "8px" }}>✅ Teste sua conexão antes da aula</li>
                          <li style={{ marginBottom: "8px" }}>✅ Instale o Microsoft Teams</li>
                          <li style={{ marginBottom: "8px" }}>✅ Prepare perguntas e anotações</li>
                        </ul>
                      </div>

                      {/* Informações importantes */}
                      <h2 
                        className="section-title"
                        style={{ 
                          fontSize: "18px", 
                          color: "#111", 
                          margin: "18px 0 10px",
                          lineHeight: "1.3",
                          display: "flex",
                          alignItems: "center",
                          gap: "8px"
                        }}
                      >
                        <svg 
                          width="29" 
                          height="29" 
                          viewBox="0 0 17.46 11.64" 
                          style={{ display: "inline-block", verticalAlign: "middle" }}
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path fill="#ff4a8f" d="M5.82,0c3.21,0,5.81,2.59,5.82,5.81,0,3.21-2.6,5.82-5.8,5.83L5.82,0h0Z"/>
                          <path fill="#3b65f5" d="M0,0c3.21,0,5.81,2.59,5.82,5.81,0,3.21-2.6,5.82-5.8,5.83L0,0h0Z"/>
                          <path fill="#c8e600" d="M11.64.03c3.21,0,5.81,2.59,5.81,5.79s-2.61,5.79-5.82,5.79V.03h0Z"/>
                        </svg>
                        Informações Importantes
                      </h2>
                      <div
                        className="warning-box"
                        style={{
                          background: "#fffbeb",
                          borderRadius: "10px",
                          padding: "18px"
                        }}
                      >
                        <ul
                          className="warning-list"
                          style={{
                            fontSize: "14px",
                            color: "#374151",
                            lineHeight: "1.9",
                            paddingLeft: "20px",
                            margin: 0
                          }}
                        >
                          <li style={{ marginBottom: "8px" }}>⏰ Chegue com 15 minutos de antecedência para o credenciamento</li>
                          <li style={{ marginBottom: "8px" }}>🪪 Traga um documento de identificação com foto</li>
                          <li style={{ marginBottom: "8px" }}>🎧 Teste seu áudio e vídeo antes do início da aula</li>
                          <li style={{ marginBottom: "8px" }}>🔗 Tenha o link da reunião salvo para acesso rápido</li>
                          <li style={{ marginBottom: "8px" }}>📜 Ao final do encontro, você receberá um certificado de participação</li>
                          <li style={{ marginBottom: "8px" }}>✉️ Em caso de dúvidas, entre em contato conosco</li>
                        </ul>
                      </div>
                    </td>
                  </tr>

                  {/* Footer */}
                  <tr>
                    <EmailFooterV2 variant="clean" showContactInfo={true} />
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  )
}
